var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"pa-4 rounded-lg py-2",staticStyle:{"border":"1px solid #bbb"}},[_c('div',[_vm._v(_vm._s(_vm.expreso.name))])])])}
var staticRenderFns = []

export { render, staticRenderFns }